module.exports = __webpack_public_path__ + "img/philosophy.4c25793.webp";